import { LoadingOverlay, Stack } from '@mantine/core';
import { ContentPlaceholder } from '../../../../../components/content-placeholder/content-placeholder';
import { secondaryBase } from '../../../../../styles/design-tokens';
import { useDataAvailable, useRelatedTasksData } from '../related-tasks-tab.hooks';
import { MainSectionControls } from './main-section-controls';
import { MainSectionTable } from './main-section-table';

export const MainSection = () => {
  const { isLoading } = useRelatedTasksData();
  const dataAvailable = useDataAvailable(isLoading);

  const content = dataAvailable ? <MainSectionTable /> : <ContentPlaceholder />;

  return (
    <Stack h="100%" style={{ overflow: 'hidden', position: 'relative' }}>
      <LoadingOverlay visible={isLoading} loaderProps={{ color: secondaryBase }} />
      <MainSectionControls />
      {content}
    </Stack>
  );
};
